import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import TOOrderDetails from "../../../components/TOOrderDetails/TOOrderDetails";
import TMLoader from "../../../components/Loader/Loader";
import { Base64func } from "../../../components/Base64Func/Base64func";
import { CgDatabase } from "react-icons/cg";
import TOPOMedBox from "./components/TOPOMedBox/TOPOMedBox";
import PickerMenu from "./components/PickerMenu/PickerMenu";
import PickerIssueModal from "./components/PickerIssueModal/PickerIssueModal";
import PickerMedPickingModal from "./components/PickerMedPickingModal/PickerMedPickingModal";
import PickerMedicineBoxLogModal from "./components/PickerMedicineBoxLogModal/PickerMedicineBoxLogModal";
import TOPOFinalScreen from "./components/PickerFinalScreen/TOPOFinalScreen";
import BarcodeScanner from "../../../components/BarcodeScanner/BarcodeScanner";
import {
  getTOPickerOrderThunk,
  fetchTOBatchesThunk,
  updateRackStatusThunk,
  getRackStatusThunk,
  fetchElasticThunk,
  getRackLocationsThunk,
  updateRackLocationThunk,
} from "../../../redux/TOThunks/Action";
import { RiErrorWarningFill } from "react-icons/ri";
import { Modal, message } from "antd";
import { CURRENT_BOX, warehouseId } from "../../../constants";
import { RackIssueModal, TOPOPageWrapper } from "./TOPOPage.styled";
export class TOPOPage extends Component {
  state = {
    serviceLoading: false,
    currentOrderId: null,
    medIssueModal: false,
    missingMedData: null,
    isFinalScreen: false,
    medData: [],
    medPickingModal: false,
    boxNumber: null,
    currTOData: null,
    openAddBoxDrawer: false,
    selectedMed: null,
    selectedMedRacks: null,
    openMedicineBoxLog: false,
    isMedErr: false,
    noRackModal: false,
  };

  componentDidMount = () => {
    let disableRefresh = true;
    // ----------- Add condition to run picking logic on picker order flow
    // ----------- Logic ( if clearPickerCondition is 1 means its page refresh show meds i.e. !e?.fullyPicked && !e.issueRaised else !e?.fullyPicked )

    window.onbeforeunload = function () {
      if (disableRefresh) {
        localStorage.setItem("clearPickerCondition", 1);
      }
    };

    //------------ Getting order ID from url

    let toId = this.props.match?.params?.TOID;
    let currentBox = localStorage.getItem(CURRENT_BOX);
    this.setState(
      {
        currentOrderId: Base64func(toId, "decode"),
        serviceLoading: true,
        boxNumber: currentBox ? JSON.parse(currentBox) : null,
      },
      () => {
        this.pageLoadApiCall();
      }
    );
  };

  getMedsCall = async () => {
    this.setState({
      serviceLoading: true,
    });

    let data = {
      access_token: this.props.access_token,
      history: this.props.history,
      toNumber: this.state.currentOrderId,
    };

    await this.props.getTOPickerOrderThunk(data).then(() => {
      this.setState({
        serviceLoading: false,
      });
      if (this.props.TOReducer?.TOOrderErr) {
        message.error(this.props.TOReducer?.TOOrderErr);
      } else {
        let medicineList = [];
        this.props.TOReducer?.TOOrderData?.medicineDetails?.map((k) =>
          medicineList.push({
            ...k,
            medIssue: false,
          })
        );
        this.setState(
          {
            currTOData: this.props.TOReducer?.TOOrderData,
            medData: medicineList,
            selectedMed: medicineList.find(
              (e) => !e?.fullyPicked && !e.issueRaised
              // localStorage.getItem("clearPickerCondition") == 1
              //   ? !e?.fullyPicked && !e.issueRaised
              //   : !e?.fullyPicked
            ),
            serviceLoading: false,
          },
          async () => {
            await this.getMedImgData();
            await this.getRackLocations();
          }
        );
      }
    });
  };

  getMedImgData = () => {
    this.setState(
      {
        serviceLoading: true,
      },
      () => {
        // let medProducts = this.state.medData
        //   ?.map((k) => k.productCode)
        //   ?.join(", ");

        let data = {
          access_token: this.props.access_token,
          history: this.props.history,
          warehouseId: warehouseId,
          isMultiSearch: false,
          elasticSearchType: "PRODUCT_CODE_SEARCH",
          searchString: this.state.selectedMed?.productCode,
        };

        this.props.fetchElasticThunk(data).then(() => {
          this.setState({
            serviceLoading: false,
          });

          if (this.props.TOReducer?.ElasticErr) {
            message.error(this.props.TOReducer?.ElasticErr);
          } else {
            let currElasticData = null;

            if (this.props.TOReducer?.ElasticData?.hits?.hits?.length > 0) {
              currElasticData = this.props.TOReducer?.ElasticData?.hits
                ?.hits[0];
            }

            let currImgs = [];

            currElasticData?._source?.product_image_urls
              ?.split(",")
              ?.map((k) => {
                currImgs.push({
                  src: k ?? "",
                  alt: "med_images",
                });
              });

            this.setState({
              selectedMed: this.state.selectedMed?.productCode
                ? {
                    ...this.state.selectedMed,
                    medImages: currImgs,
                  }
                : null,
            });
          }
        });
      }
    );
  };

  getRackLocations = async () => {
    this.setState({
      serviceLoading: true,
    });

    let data = {
      access_token: this.props.access_token,
      // medData: [this.state.selectedMed?.productCode],
      toId: this.state.currentOrderId,
      warehouseId: warehouseId,
      productCodes: [this.state.selectedMed?.productCode],
    };

    await this.props.getRackLocationsThunk(data).then(() => {
      this.setState({
        serviceLoading: false,
      });
      if (this.props.TOReducer?.GetRackLocationErr) {
        message.error(this.props.TOReducer?.GetRackLocationErr);

        this.setState({
          selectedMedRacks: null,
          noRackModal: true,
        });
      } else {
        if (
          this.props.TOReducer?.GetRackLocationData?.remainingQuantity != 0 &&
          (this.props.TOReducer?.GetRackLocationData?.bulkLocation?.length ==
            0 ||
            this.props.TOReducer?.GetRackLocationData?.jitLocation?.length == 0)
        ) {
          this.setState({
            selectedMedRacks: this.props.TOReducer?.GetRackLocationData,
            noRackModal: true,
          });
          message.error("No rack locations found");
        } else {
          this.setState({
            selectedMedRacks: this.props.TOReducer?.GetRackLocationData,
          });
        }
      }
    });
  };

  getMedBatchesCall = async () => {
    this.setState({
      serviceLoading: true,
    });

    let data = {
      access_token: this.props.access_token,
      history: this.props.history,
      warehouseId: warehouseId,
      // warehouseId: 3,
      productCodes: [this.state.selectedMed?.productCode],
    };

    await this.props.fetchTOBatchesThunk(data).then(() => {
      this.setState({
        serviceLoading: false,
      });
      if (this.props.TOReducer?.TOMedBatchesErr) {
        message.error(this.props.TOReducer?.TOMedBatchesErr);
      } else if (this.props.TOReducer?.TOMedBatchesData) {
        let { selectedMed } = this.state;

        selectedMed.batches =
          this.props.TOReducer?.TOMedBatchesData?.item_stock[0]?.batches ?? [];

        this.setState({
          selectedMed,
        });
      }
    });
  };

  pageLoadApiCall = async () => {
    this.setState({ serviceLoading: true });

    await this.getMedsCall();
    await this.getMedBatchesCall();
  };

  pageLoadToggle = (value) => {
    this.setState({ serviceLoading: value });
  };

  handlePicked = () => {
    // ------------- Picking func
    this.setState({
      medPickingModal: true,
    });
  };

  handleLastMed = () => {
    let isErrorArr = this.state.medData?.filter((e) => e?.issueRaised);
    this.setState({
      isFinalScreen: true,
      isMedErr: isErrorArr?.length > 0 ? true : false,
    });
  };

  handleNextMedicine = () => {
    // ------------ NextMedicine For All
    let { medData } = this.state;
    medData = medData?.map((e) => {
      if (e?.productCode == this.state.selectedMed?.productCode) {
        e.fullyPicked = true;
      }
      return e;
    });
    this.setState(
      {
        medPickingModal: false,
        medData,
        selectedMed:
          medData?.find(
            (e) => !e?.fullyPicked && !e.issueRaised
            // localStorage.getItem("clearPickerCondition") == 1
            //   ? !e?.fullyPicked && !e.issueRaised
            //   : !e?.fullyPicked
          ) ?? null,
      },
      async () => {
        if (this.state.selectedMed) {
          await this.getMedImgData();
          await this.getRackLocations();
          await this.getMedBatchesCall();
        }
        message.success("Picked successfully");
      }
    );
  };

  handleAddBox = () => {
    this.setState({
      openAddBoxDrawer: true,
    });
  };
  handleIssueMarked = () => {
    let { selectedMed, medData } = this.state;
    medData = medData?.map((e) => {
      if (e && selectedMed?.productCode === e?.productCode) {
        e.issueRaised = true;
      }
      return e;
    });
    this.setState(
      {
        medData: medData,
        medIssueModal: false,
        selectedMed:
          medData?.find(
            (e) => !e?.fullyPicked && !e.issueRaised
            // localStorage.getItem("clearPickerCondition") == 1
            //   ? !e?.fullyPicked && !e.issueRaised
            //   : !e?.fullyPicked
          ) ?? null,
      },
      async () => {
        if (this.state.selectedMed) {
          await this.getMedImgData();
          await this.getRackLocations();
          await this.getMedBatchesCall();
        }

        message.success("Issue marked successfully");

        //if no medicine is left in selected med
        if (!this.state.selectedMed || !this.state.selectedMed?.productCode) {
          this.handleLastMed();
        }
        // this.props.history.push("/to-picker");
      }
    );
  };
  updateBoxNumber = (value) => {
    this.setState({
      boxNumber: value,
    });
    localStorage.setItem(CURRENT_BOX, JSON.stringify(value));
  };
  rackUpdateServiceCall = (data) => {
    this.setState({ serviceLoading: true });

    if (!this.state.boxNumber) {
      message.warning("Invalid box number !");
      return;
    }

    let log = {
      access_token: this.props.access_token,
      history: this.props.history,
      warehouseId: warehouseId,
      toId: this.state.currentOrderId,
      pickedQuantity: data.pickedQty,
      productCode: this.state.selectedMed?.productCode,
      location: encodeURIComponent(
        data.isJit ? data.jitLocation : data.bulkLocation
      ),
      boxNumber: this.state.boxNumber,
      batchNumber: encodeURIComponent(
        this.state.selectedMedRacks[0]?.batchNumber
      ),
      reasonId: data.reasonId,
      type: data.isJit ? "Jit" : "Bulk",
    };

    // this.props.updateRackStatusThunk(log).then(() => {
    this.props.updateRackLocationThunk(log).then(() => {
      this.setState({
        serviceLoading: false,
      });
      if (this.props.TOReducer?.UpdateRackLocationErr) {
        message.error(this.props.TOReducer?.UpdateRackLocationErr);
      } else if (this.props.TOReducer?.UpdateRackLocationData) {
        message.success("Rack locations updated");
        this.getRackLocations();
      }
    });
  };
  render() {
    let {
      currentOrderId,
      serviceLoading,
      selectedMed,
      missingMedData,
      medIssueModal,
      medData,
      medPickingModal,
      openMedicineBoxLog,
      isFinalScreen,
      openAddBoxDrawer,
      isMedErr,
      selectedMedRacks,
    } = this.state;

    return isFinalScreen ? (
      <>
        <TOPOFinalScreen isError={isMedErr} isLoading={serviceLoading} />
      </>
    ) : (
      <TOPOPageWrapper>
        {serviceLoading ? <TMLoader /> : null}
        <TOOrderDetails
          toData={this.state.currTOData}
          warehouseList={this.props.warehouseList}
          boxNumber={this.state.boxNumber}
        />

        {/* // --------------------------------------- Box log data here */}

        <button
          className="bbtn"
          onClick={() => {
            this.setState({
              openMedicineBoxLog: true,
            });
          }}
        >
          <CgDatabase /> Medicine box log
        </button>
        <br />

        {/* // --------------------------------------- Medicine Level data */}

        <TOPOMedBox
          selectedMed={selectedMed}
          rackApi={this.rackUpdateServiceCall}
          selectedRack={
            selectedMedRacks?.length > 0 ? selectedMedRacks[0] : null
          }
        />

        {/* // --------------------------------------- Picker actions */}

        <PickerMenu
          selectedMedRacks={selectedMedRacks && selectedMedRacks[0]}
          handleAddBox={() => {
            this.handleAddBox();
          }}
          handlePicked={() => this.handlePicked()}
          missingMedData={missingMedData}
          toggleIssueModal={(value) =>
            this.setState({
              medIssueModal: value,
            })
          }
          serviceLoading={serviceLoading}
        />

        {/* // --------------------------------------- Med Issue Modal */}

        {medIssueModal ? (
          <PickerIssueModal
            markPickerIssueFailure={this.props.markPickerIssueFailure}
            markPickerIssueSuccess={this.props.markPickerIssueSuccess}
            toggleMedIssueModal={(value) => {
              this.setState({ medIssueModal: value });
            }}
            handleIssueMarked={() => {
              this.handleIssueMarked();
            }}
            currTOId={currentOrderId}
            currBoxNumber={this.state.boxNumber}
            selectedMed={selectedMed}
            medIssueModal={medIssueModal}
            medData={medData}
            pageLoadToggle={(value) => this.pageLoadToggle(value)}
          />
        ) : (
          ""
        )}

        {/* // --------------------------------------- No rack Modal */}

        <RackIssueModal
          // title="Pick Medicine"
          open={this.state.noRackModal}
          // open={true}
          centered
          closeIcon={null}
          onCancel={() => this.setState({ noRackModal: false })}
          // className="medPickingModal"
          footer={null}
        >
          <div className="modalWrapper">
            <RiErrorWarningFill className="warnicon" />
            <p>Please mark medicine issue to continue... </p>
          </div>
        </RackIssueModal>

        {/* // --------------------------------------- Med Picked Modal */}
        <PickerMedPickingModal
          access_token={this.props.access_token}
          medPickingModal={medPickingModal}
          toggleMedPickingModal={(value) => {
            this.setState({
              medPickingModal: value,
            });
          }}
          productCode={this.state.selectedMed?.productCode}
          medName={this.state.selectedMed?.skuName}
          currentQty={this.state.selectedMed?.quantity}
          boxNumber={this.state.boxNumber}
          toNumber={currentOrderId}
          nextMedicine={() => this.handleNextMedicine()}
          handleLastMed={() => this.handleLastMed()}
          pendingQuantity={this.state.selectedMed?.pendingQuantity ?? 0}
          updateBoxNumber={(value) => this.updateBoxNumber(value)}
          pageLoadToggle={(value) => this.pageLoadToggle(value)}
        />

        {/* // --------------------------------------- Med Log Modal */}
        {openMedicineBoxLog ? (
          <PickerMedicineBoxLogModal
            openMedicineBoxLog={openMedicineBoxLog}
            toggleMedicineBoxLog={(value) => {
              this.setState({
                openMedicineBoxLog: value,
              });
            }}
            medBoxLogFailure={this.props.medBoxLogFailure}
            medBoxLogSuccess={this.props.medBoxLogSuccess}
            access_token={this.props.access_token}
            toNumber={currentOrderId}
          />
        ) : (
          ""
        )}

        {openAddBoxDrawer ? (
          <BarcodeScanner
            boxNumber={this.state.boxNumber}
            scan={openAddBoxDrawer ? true : false}
            camera={openAddBoxDrawer ? true : false}
            redirect={"to-picker-same-page"}
            orderId={currentOrderId}
            history={this.props.history}
            updateCurrentBox={(boxId) => {
              this.setState({
                boxNumber: boxId,
              });
              localStorage.setItem(CURRENT_BOX, JSON.stringify(boxId));
            }}
            boxUpdate={true}
            getBoxId={() => this.setState({ openAddBoxDrawer: false })}
          />
        ) : null}
      </TOPOPageWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  isOnline: state.statusReducer?.isOnline,
  TOReducer: state.TOReducer,
  warehouseList: state.authReducer?.AuthData?.warehouseList,
  markPickerIssueSuccess: state.pickerTOReducer.markPickerIssueSuccess,
  markPickerIssueFailure: state.pickerTOReducer.markPickerIssueFailure,
  medBoxLogSuccess: state.pickerTOReducer.MedicineBoxLogSuccess,
  medBoxLogFailure: state.pickerTOReducer.MedicineBoxLogFailure,
  saveQuantityInBoxSuccess: state.pickerTOReducer.SaveQuantityDetailsSuccess,
  saveQuantityInBoxFailure: state.pickerTOReducer.SaveQuantityDetailsFailure,
});

const mapDispatchToProps = {
  getTOPickerOrderThunk,
  fetchTOBatchesThunk,
  updateRackStatusThunk,
  getRackStatusThunk,
  fetchElasticThunk,
  getRackLocationsThunk,
  updateRackLocationThunk,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TOPOPage)
);
